import { snackStore } from 'stores';

import { SNACK_SCOPES } from '../../../constants';

import { changeDistanceEmailMismatchSnack } from './emailMismatch';
import { changeDistanceUnusableTokenSnack } from './unusableToken';

function clean() {
  snackStore.removeAll((snack) => snack.options?.scope === SNACK_SCOPES.changeDistance);
}

export const changeDistance = {
  changeDistanceUnusableTokenSnack,
  changeDistanceEmailMismatchSnack,
  clean,
};
